<script>
   /**************************************************************/
   /* Svelte component for ExtremePlot settings                  */
   /**************************************************************/

   import { Container, CompSelector } from '../controls';

   export let params;
   export let model;
   export let res;

   let ncomp = 1;

   $: params = {
      ncomp,
   }
</script>


<Container label="">
<p class="title">Extremes</p>
</Container>

{#if model && res}
<CompSelector bind:value={ncomp} label="# PCs" {model} />
{/if}


